import React from 'react';
import LargeButton from '../shared/components/LargeButton';
import PrivilegeNames from '../../constants/privilegeNames';
import { useReactiveVar } from '@apollo/client';
import { userPrivileges } from '../../apollo/cache';

/**
 * @typedef {object} NotFoundButtonsProps
 * @property {(path: string) => void} [handleBtnClick]
 */

/**
 * @param {NotFoundButtonsProps} props
 */
const NotFoundButtons = props => {
  const { handleBtnClick } = props;
  const privileges = useReactiveVar(userPrivileges);

  return (
    privileges && (
      <>
        {privileges.includes(PrivilegeNames.IndustryReports) && (
          <LargeButton
            subText='View broader industry data trends'
            onClick={() => handleBtnClick('/data-reports/industry-reports')}>
            Industry Reports
          </LargeButton>
        )}
        {privileges.includes(PrivilegeNames.OrganizationReports) && (
          <LargeButton
            subText='View individual organizational data'
            onClick={() => handleBtnClick('/data-reports/organization-reports')}>
            Organization Reports
          </LargeButton>
        )}
        {privileges.includes(PrivilegeNames.Resources) && (
          <LargeButton
            subText='View available VIP resources'
            onClick={() => handleBtnClick('/resources#search-resources')}>
            Resources
          </LargeButton>
        )}
      </>
    )
  );
};

export default NotFoundButtons;
